import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useAnalytics } from '../../../app/data/AnalyticsProvider';
import { useStore } from '../../../app/data/root.store';
import { ReactComponent as ManageMyWealthSvgHover } from '../../../onboarding/components/Questionnaire/assets/manage-my-wealth-hover.svg';
import { ReactComponent as ManageMyWealthSvg } from '../../../onboarding/components/Questionnaire/assets/manage-my-wealth.svg';
import { ReactComponent as ManageOthersWealthSvgHover } from '../../../onboarding/components/Questionnaire/assets/manage-others-wealth-hover.svg';
import { ReactComponent as ManageOthersWealthSvg } from '../../../onboarding/components/Questionnaire/assets/manage-others-wealth.svg';
import { QuestionnaireContentWrapper, QuestionnaireTitleWrapper, WealthManagementTypeAnswerItemWrapper, WealthManagementTypeAnswersWrapper } from '../../../onboarding/components/Questionnaire/OnBoardingQuestionnaire.styles';
import { AdamImageComponent } from '../../../user-activation-flow/components/steps/MeetAdamStep';
import { AUTH_STEPS } from '../../../user/data/user.store';
import { StyledSignUpStepWrapper, WealthManagementHeader, WealthManagementSubHeader } from '../LoginPage.styles';
import { useTrackEvent } from '../../../../hooks/useTrackEvent/useTrackEvent';

export const WealthManagementTypeStep = observer(() => {
  const { userStore } = useStore();
  const { trackEvent } = useAnalytics();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const stepData = {
    title: 'Who do you manage wealth for?',
    subTitle: `Hi, I’m Adam, your personal onboarding guide.`,
    answerOptions: [
      { label: 'I manage wealth for others', icon: <ManageOthersWealthSvg />, value: 'others_wealth', hoverIcon: <ManageOthersWealthSvgHover /> },
      { label: 'I manage my own wealth', icon: <ManageMyWealthSvg />, value: 'own_wealth', hoverIcon: <ManageMyWealthSvgHover /> },
    ]
  };

  const handleOptionSelect = (value) => {
    trackEvent('Questionnaire Step Completed', {
      step_name: 'wealth_management_type',
      step_selections: value,
      step_flow: value === 'own_wealth' ? 'b2c' : 'b2b',
      location: 'pre_signup',
    });
    userStore.setAuthFields('wealthManagementType', value);
    if (value === 'own_wealth') {
      userStore.setAuthFields('clientCount', null);
      userStore.setAuthStep(AUTH_STEPS.GREETING_STEP);
    } else {
      userStore.setAuthStep(AUTH_STEPS.CLIENT_COUNT_STEP);
    }
  };

  useTrackEvent('Questionnaire Step Viewed', {
    step_name: 'wealth_management_type',
    location: 'pre_signup',
  });

  return (
    <StyledSignUpStepWrapper>
      <QuestionnaireTitleWrapper style={{marginTop: '106px'}}>
        <AdamImageComponent size={48} />
        <WealthManagementSubHeader>{stepData.subTitle}</WealthManagementSubHeader>
        <WealthManagementHeader>{stepData.title}</WealthManagementHeader>
      </QuestionnaireTitleWrapper>
      
      <QuestionnaireContentWrapper>
        <WealthManagementTypeAnswersWrapper>
          {stepData.answerOptions.map((option, index) => (
            <WealthManagementTypeAnswerItemWrapper 
              key={index}
              index={index}
              onClick={() => handleOptionSelect(option.value)}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              {hoveredIndex === index ? option.hoverIcon : option.icon}
              {option.label}
            </WealthManagementTypeAnswerItemWrapper>
          ))}
        </WealthManagementTypeAnswersWrapper>
      </QuestionnaireContentWrapper>
    </StyledSignUpStepWrapper>
  );
});